import { defineComponent as _defineComponent } from 'vue'
import { IMonthly } from '@/modules/investments/types/Performance';
import { computed } from 'vue';
import { Money } from '@/modules/common/components/Money';
import {
  Modal,
  HeadingDisplay,
  Row,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
interface Props {
  details: IMonthly | null;
  benchmarkSelected: string;
  benchmarkComparisonSelected: string;
  showModal: boolean;
}

interface Emits {
  (event: 'close'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceDetail',
  props: {
    details: null,
    benchmarkSelected: null,
    benchmarkComparisonSelected: null,
    showModal: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props as {
  details: IMonthly | null;
  benchmarkSelected: string;
  benchmarkComparisonSelected: string;
  showModal: boolean;
}





const rows = computed(() => {
  const lines = [
    {
      leftTitle: 'Rendimento bruto',
      rightTitle: props.details?.values?.profitValues?.formatted,
      leftSubtitle: 'Inclui proventos e cashback'
    },
    {
      leftTitle: 'Rentabilidade bruta',
      rightTitle: props.details?.values?.returns?.formatted,
      leftSubtitle: getBenchmarkComparisonValue(
        props.details?.values?.benchmarkComparison?.formatted
      ),
      colorLeftSubtitle: !props.details?.values?.benchmarkComparison?.isNegative
        ? NebraskaColors.monetaryPositive
        : NebraskaColors.monetaryNegative
    }
  ];
  if (props.benchmarkSelected && props.details?.values?.benchmark?.formatted) {
    lines.push({
      leftTitle: props.benchmarkSelected,
      rightTitle: props.details?.values?.benchmark?.formatted
    });
  }
  return lines;
});

const getBenchmarkComparisonValue = (value: string) => {
  if (!props?.benchmarkSelected) return '';
  return props?.benchmarkSelected === 'CDI'
    ? `${value} do CDI`
    : `${props?.benchmarkComparisonSelected} ${value}`;
};

return { __sfc: true,props, rows, getBenchmarkComparisonValue, Money, Modal, HeadingDisplay, Row, BaseText, NebraskaColors }
}

})